import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Step, Icon, Grid, Segment, Container } from "semantic-ui-react";
import AddVehicle from "../addVehicle";
import PaymentDetails from "./PaymentDetails";
import addVehicle from "../../modules/vehicles/addVehicle";
import AccountAppRedirect from "../accountAppRedirect";
import { ACCOUNT_APP_AUTOPAY, ACCOUNT_APP_CARD, isPinnedToLegacyApp } from "../../modules/accountApp";

class DriverSettingsWizard extends Component {
  render() {
    const { hasPaymentCard, vehicles, initialised } = this.props;
    const requiresVehicle = vehicles.length === 0;
    const requiresPaymentCard = !hasPaymentCard;

    // Gated on `initialised`: a failed dashboard fetch leaves vehicles empty and
    // hasPaymentCard false, which is indistinguishable from a new driver here. Drop
    // the gate and an API blip throws people out of the app.
    if (initialised && (requiresVehicle || requiresPaymentCard) && !isPinnedToLegacyApp()) {
      return <AccountAppRedirect path={requiresVehicle ? ACCOUNT_APP_AUTOPAY : ACCOUNT_APP_CARD} />;
    }

    if (requiresVehicle || requiresPaymentCard) {
      return (
        <div>
          <div className="tagline">
            <Container>
              <Grid stackable textAlign="left">
                <Grid.Row columns={1}>
                  <Grid.Column>
                    <h1>Sign up to Hozah Autopay</h1>
                    <p>It’s fast, secure and you won’t be charged until your first eligible parking session.</p>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Container>
          </div>

          <div className="section">
            <Container>
              <Grid stackable textAlign="left">
                <Grid.Row columns={2}>
                  <Grid.Column width={10}>
                    <div>
                      <div id="w-node-6f2801999db4-7c09cd64" className="progress-block-new progress-block-complete-new">
                        <div className="progress-number-new new-branding-progress-complete">1</div>
                        <div className="progress-title-new h2">Tell us about you</div>
                      </div>{" "}
                      <div className="steps-divider"></div>
                      {requiresVehicle ? (
                        <div id="w-node-6f2801999db9-7c09cd64" className="progress-block-new progress-block-active-new">
                          <div className="progress-number-new new-branding-progress-number">2</div>
                          <div className="progress-title-new h2">Find your vehicle</div>
                        </div>
                      ) : (
                        <div id="w-node-6f2801999db9-7c09cd64" className="progress-block-new progress-block-complete-new">
                          <div className="progress-number-new new-branding-progress-complete">2</div>
                          <div className="progress-title-new h2">Find your vehicle</div>
                        </div>
                      )}
                      {requiresVehicle ? <AddVehicle hideBackLink={true} /> : null}
                      <div className="steps-divider"></div>
                      {!requiresVehicle && requiresPaymentCard ? (
                        <div id="w-node-6f2801999dbe-7c09cd64" className="progress-block-new progress-block-active-new">
                          <div className="progress-number-new new-branding-progress-number">3</div>
                          <div className="progress-title-new h2">Enter payment details</div>
                        </div>
                      ) : (
                        <div id="w-node-6f2801999dbe-7c09cd64" className="progress-block-new">
                          <div className="progress-number-new new-branding-progress-number">3</div>
                          <div className="progress-title-new h2">Enter payment details</div>
                        </div>
                      )}
                      {requiresVehicle ? null : <PaymentDetails initialEntry="Yes" key={1} />}
                    </div>
                  </Grid.Column>

                  <Grid.Column width={6}>
                    <div className="sidebar">
                      <div id="secure-payment">
                        <div className="icon-list-new">
                          <p className="h5">
                            <strong>Secure payment by</strong>
                          </p>
                          <div>
                            <img src="images/payment-icons.png" />
                          </div>
                        </div>
                      </div>
                      <div id="why-use-hozah">
                        <div className="icon-list-new">
                          <p className="h5">
                            <strong>Why Use Hozah Autopay?</strong>
                          </p>
                          <p className="small">One-time sign up for accurate, automatic payments whenever you visit a Hozah Autopay-enabled car park.</p>
                          <p className="small">Convenience fee of up to 25p applies per parking session (varies by car park).</p>
                          <div className="new-branding-icons">
                            <div className="icon-list-item-new new-branding-icon-container">
                              <img src="images/new-branding-cash.png" width="32" alt="" />
                              <p className="icon-description-new new-branding-icon-text">No need to carry cash</p>
                            </div>
                            <div className="icon-list-item-new new-branding-icon-container">
                              <img src="images/new-branding-clock.png" width="32" alt="" />
                              <p className="icon-description-new new-branding-icon-text">No waiting at the ticket machine</p>
                            </div>
                            <div className="icon-list-item-new new-branding-icon-container">
                              <img src="images/new-branding-phone.png" width="32" alt="" />
                              <p className="icon-description-new new-branding-icon-text">No need to download an app</p>
                            </div>
                            <div className="icon-list-item-new new-branding-icon-container">
                              <img src="images/new-branding-h.png" width="32" alt="" />
                              <p className="icon-description-new new-branding-icon-text">
                                <strong>Simply park and go</strong>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Container>
          </div>
        </div>
      );
    } else {
      return this.props.children;
    }
  }
}

const mapStateToProps = (state) => ({
  hasPaymentCard: state.dashboard.hasPaymentCard,
  vehicles: state.dashboard.vehicles,
  initialised: state.dashboard.initialised,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DriverSettingsWizard);
